import PropTypes from 'prop-types';
import React from 'react';
import './TypingIndicator.scss';

function TypingIndicator({ className, inline }) {
  return (
    <div className={`typing-indicator ${inline ? 'typing-indicator--inline' : ''} ${className || ''}`}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

TypingIndicator.propTypes = {
  className: PropTypes.string,
  inline: PropTypes.bool,
};

TypingIndicator.defaultProps = {
  className: '',
  inline: false,
};

export default TypingIndicator;
